// Dependencies
import { FC, ReactElement } from "react";

// Components
import { SnackbarProvider, closeSnackbar } from "notistack";

// Styles
import {
  StyledCloseButton,
  StyledMaterialDesignContent,
} from "./NotiStackWrapper.styled";

interface NotiStackWrapperProps {
  children: ReactElement;
}

const NotiStackWrapper: FC<NotiStackWrapperProps> = ({ children }) => {
  return (
    <SnackbarProvider
      Components={{
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        default: StyledMaterialDesignContent,
        info: StyledMaterialDesignContent,
      }}
      action={(id) => (
        <StyledCloseButton onClick={() => closeSnackbar(id)}>
          close
        </StyledCloseButton>
      )}
      maxSnack={3}
      autoHideDuration={5000}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      {children}
    </SnackbarProvider>
  );
};

export default NotiStackWrapper;
